const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Rubric Chart component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('rubricChart', ['$translate', function ($translate) {
  return {
    restrict: 'E',
    scope: {
      data: '=',
      userData: '=',
      usersOverlay: '='
    },
    template: require('../../../templates/directives/assessments/rubric-chart.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.translations = {};
      var chart = {
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scaleShowVerticalLines: false,
          scaleLineColor: '#f7f7f7',
          scaleFontSize: 10,
          scaleFontFamily: '"Gotham SSm A","Gotham SSm B",Helvetica,Arial,sans-serif',
          pointLabelFontFamily : '"Gotham SSm A","Gotham SSm B",Helvetica,Arial,sans-serif',
          pointLabelFontColor : "#7D7D7D",
          pointLabelFontSize: 14,
          pointDotRadius : 0,
          pointDotStrokeWidth : 0,
          bezierCurve : false,
          showTooltips: false,
          scaleShowLabels: true,
          scaleOverride: true,
          scaleStepWidth: 20,
          scaleStartValue: 0,
          scaleSteps: 5,
          angleLineColor : '#f7f7f7'
        },
        colorConfig: {
          baseColors: [],
          currColors: [],
          dimmedColor: {},
          defaultColors: [0,1,2,3]
        },
        getColor : function(color) {
          return {
            backgroundColor: color[0], 
            borderColor: color[1],
            pointBackgroundColor: color[1], 
            pointBorderColor: 'white', 
            pointHoverBackgroundColor: color, 
            pointHoverBorderColor: 'white'
          };
        }
      };

      chart.colorConfig.baseColors = [['rgba(33,190,241,.1)','#21bef1'], ['rgba(54,194,110,.1)','#36c26e'], ['rgba(232,98,87,.1)','#e86257'], ['rgba(253,129,38,.1)','#fd8126'], ['rgba(147,149,151,.1)','#c9cacb']];
      chart.colorConfig.defaultColors = chart.colorConfig.defaultColors.map(function(idx){ return chart.getColor(chart.colorConfig.baseColors[idx]) } );
      chart.colorConfig.dimmedColor = chart.getColor(chart.colorConfig.baseColors[4]);
      chart.colorConfig.currColors = chart.colorConfig.defaultColors;

      self.initialize = function() {
        chart.colours = chart.colorConfig.defaultColors;

        chart.labels = $scope.data.names;
        chart.data = [$scope.data.mean_values];
        chart.seriesLabels = [self.translations['rubricChart.all_scores']];
        self.chart = chart;
      };

      $translate(['rubricChart.all_scores']).then(function (translations) {
        self.translations = translations;
        if ($scope.data) {
          self.initialize();
        };
      });

      $scope.$watch('data', function(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          self.initialize();
        }
      }, true);

      $scope.$watch('usersOverlay', function(newVal, oldVal) {
        if (!$scope.data || !$scope.data.rubric_ids || !$scope.data.rubric_ids.length) {
          return;
        }
        if (newVal && newVal !== oldVal) {
          var seriesData = [chart.data[0]];
          var seriesLabels = ['All Scores'];
          for (var key in $scope.usersOverlay) {
            var data = $scope.userData[key];
            if (!data.length) {
              return;
            }
            data = data[data.length - 1];
            var values = [];
            $scope.data.rubric_ids.forEach(function(id) {
              values.push(data[id] || 0);
            });
            seriesData.push(values);
            seriesLabels.push($scope.usersOverlay[key] && $scope.usersOverlay[key].full_name || '--');
          };
          chart.data = seriesData;
          chart.seriesLabels = seriesLabels;
        }
      }, true);

    }],
    controllerAs: 'rubricData'
  };
}]);

